module.exports = __webpack_public_path__ + "static/user-thumbnail-3-2d27b8ed755f5dbe06201810f843b006.jpg";